import React from 'react'

import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { useTranslationRankmi } from 'helpers/translations.helper'

interface PublishNormativeWithoutDc3ModalProps {
  isOpen: boolean
  processing?: boolean
  onClose: () => void
  onPublishAndAssociate: () => void
}

export const PublishNormativeWithoutDc3Modal: React.FC<PublishNormativeWithoutDc3ModalProps> =
  ({ isOpen, processing = false, onClose, onPublishAndAssociate }) => {
    const t = useTranslationRankmi({
      prefix: 'administration.lessons.publishNormativeModal',
    })

    return (
      <Modal
        isOpen={isOpen}
        title={t('title')}
        isConfirmation
        maxwidth={800}
        maxheight={400}
        close={onClose}
        actions={
          <ModalButtons
            secondaryText={t('cancel')}
            secondaryAction={onClose}
            disableSecondaryButton={processing}
            primaryText={t('publishAndAssociate')}
            primaryAction={onPublishAndAssociate}
            disablePrimaryButton={processing}
            processing={processing}
          />
        }
      >
        {String(t('body'))}
      </Modal>
    )
  }

export default PublishNormativeWithoutDc3Modal
